import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main/main.component';
import { RouterModule, Route } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { UtilModule } from '../util/util.module';
import { BaseService } from '../util/base-service.service';
import { HttpModule } from '@angular/http';
import { MainComponent as GeneracionClaveMainComponent} from './../seguridad/generacionclave/main/main.component';
import { MainComponent as CambioClaveMainComponent} from './../seguridad/cambioclave/main/main.component';
import { MainComponent as CambioPorExpiracionMainComponent} from './../seguridad/cambioporexpiracion/main/main.component';
import { MainComponent as DesafiliacionMainComponent} from './../seguridad/desafiliacion/main/main.component';
import { NumberOnlyDirective } from './main/number.directive';
import { MaintenanceComponent } from './maintenance/maintenance.component';

const routes: Route[] = [
  // {
  //   path: '',
  //   component: MaintenanceComponent,
  // },
  {
    path: '',
    component: MainComponent
  },
  {
    path: 'generarclave',
    component: GeneracionClaveMainComponent,
    loadChildren: './../seguridad/generacionclave/generacionclave.module#GeneracionclaveModule',
  },
  {
    path: 'cambiarclave',
    component: CambioClaveMainComponent,
    loadChildren: './../seguridad/cambioclave/cambioclave.module#CambioclaveModule',
  },
  {
    path: 'cambiarclaveexpirada',
    component: CambioPorExpiracionMainComponent,
    loadChildren: './../seguridad/cambioporexpiracion/cambioporexpiracion.module#CambioporexpiracionModule',
  },
  {
    path: 'desafiliacion',
    component: DesafiliacionMainComponent,
    loadChildren: './../seguridad/desafiliacion/desafiliacion.module#DesafiliacionModule',
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    HttpModule,
    UtilModule
  ],
  declarations: [MainComponent, GeneracionClaveMainComponent, CambioClaveMainComponent, CambioPorExpiracionMainComponent, DesafiliacionMainComponent,NumberOnlyDirective, MaintenanceComponent],
  providers: [BaseService]
})
export class SeguridadModule { }
